export default {
    items: [],
    loading: false,
    cbs: [],
    time: 0,
}